/**
 * Created by Bart Decorte
 * Date: 06/07/2020
 * Time: 10:51
 */
import DangerToast from './DangerToast';
import Toast from './Toast';
import InfoToast from './InfoToast';

let instance;

class ToastManager {
  constructor() {
    this.toasts = [];
  }

  default(body, header) {
    const toast = new Toast(body, header)
    this
      .register(toast)
      .show(toast);
  }

  danger(body, header) {
    const toast = new DangerToast(body, header)
    this
      .register(toast)
      .show(toast);
  }

  info(body, header) {
    const toast = new InfoToast(body, header)
    this
      .register(toast)
      .show(toast);
  }

  register(toast) {
    this.toasts.push(toast);
    return this;
  }

  show(toast) {
    toast.show();
  }
}

const toasts = () => {
  if (typeof instance === typeof undefined) {
    instance = new ToastManager();
  }

  return instance;
}

export { toasts as default, toasts };



// WEBPACK FOOTER //
// ./resources/assets/js/toasts/ToastManager.js